export default __webpack_public_path__ + "static/media/all-temples-visshkapatnam-card-img.85316809.png";